import { OtherPaymentPaymentType } from 'src/app/payroll/other-payments/models/other-payments-paytype.enum';
import { MarginExpenseTypes } from '../../locums-margin-calculator/enums/margin-expense-types.enum';

//SELECT * FROM Billing.ExternalPaymentTypeNames
export const marginExpenseTypeToPaymentType: Partial<Record<MarginExpenseTypes, number>> = {
    [MarginExpenseTypes.AIRFARE]: OtherPaymentPaymentType.AIRFARE,
    [MarginExpenseTypes.RENTAL_CAR]: OtherPaymentPaymentType.RENTAL_CAR,
    [MarginExpenseTypes.HOUSING]: OtherPaymentPaymentType.HOTEL_REIMBURSEMENT
};
